/**
 * Generates a cryptographically secure random nonce
 * @param {number} length - Length of the nonce (default: 16)
 * @returns {string} - Random alphanumeric string
 */
const generateNonce = (length = 16) => {
  let result = "";
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  for (let i = 0; i < length; i++) {
    let randomIndex;
    
    // Use crypto.getRandomValues for browser compatibility (instead of randomBytes)
    if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
      const randomArray = new Uint8Array(1);
      crypto.getRandomValues(randomArray);
      randomIndex = randomArray[0] % characters.length;
    } else {
      // Fallback to Math.random if crypto is not available
      randomIndex = Math.floor(Math.random() * characters.length);
    }
    
    result += characters[randomIndex];
  }
  return result;
};

export default generateNonce;